import { WidgetsSplitDistributeMain } from '@/widgets/split-distribute';

export const PagesSplitDetailMain = () => <WidgetsSplitDistributeMain />;
